import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
var NativeMenu = /** @class */ (function (_super) {
    __extends(NativeMenu, _super);
    function NativeMenu() {
        return _super.call(this) || this;
    }
    NativeMenu.classInitializer = null;
    NativeMenu.classSymbols = null; // [];
    NativeMenu.instanceSymbols = null; // [];
    return NativeMenu;
}(EventDispatcher));
export { NativeMenu };
